import type { CSSProperties } from 'react';

const DEPLOY_INSPECT_ROW_GAP = 8;
const DEPLOY_INSPECT_SHELL_BORDER = '1px solid rgba(255, 255, 255, 0.08)';
const DEPLOY_INSPECT_SHELL_RADIUS = '50px';
const DEPLOY_INSPECT_SHELL_TRANSITION =
  'background 200ms ease-in-out, box-shadow 200ms ease-in-out, border 200ms ease-in-out, ' +
  'border-radius 200ms ease-in-out, padding 200ms ease-in-out, opacity 200ms ease-in-out';
export const DEPLOY_INSPECT_ROW_ALIGN_ITEMS = 'center';
export const DEPLOY_INSPECT_ROW_DISPLAY = 'flex';
export const DEPLOY_INSPECT_ROW_FLEX_DIRECTION = 'row';
export const DEPLOY_INSPECT_ROW_FLEX_WRAP = 'nowrap';
export const DEPLOY_INSPECT_ROW_JUSTIFY_CONTENT = 'center';
export const DEPLOY_INSPECT_SHELL_BLUR = 'blur(1px)';

export const DEPLOY_INSPECT_ROW_STYLE: CSSProperties = {
  alignItems: DEPLOY_INSPECT_ROW_ALIGN_ITEMS,
  display: DEPLOY_INSPECT_ROW_DISPLAY,
  flexDirection: DEPLOY_INSPECT_ROW_FLEX_DIRECTION,
  flexWrap: DEPLOY_INSPECT_ROW_FLEX_WRAP,
  gap: DEPLOY_INSPECT_ROW_GAP,
};

export const DEPLOY_INSPECT_SHELL_STYLE: CSSProperties = {
  ...DEPLOY_INSPECT_ROW_STYLE,
  WebkitBackdropFilter: DEPLOY_INSPECT_SHELL_BLUR,
  backdropFilter: DEPLOY_INSPECT_SHELL_BLUR,
  border: DEPLOY_INSPECT_SHELL_BORDER,
  borderRadius: DEPLOY_INSPECT_SHELL_RADIUS,
  boxSizing: 'border-box',
  justifyContent: DEPLOY_INSPECT_ROW_JUSTIFY_CONTENT,
  transition: DEPLOY_INSPECT_SHELL_TRANSITION,
};
